import cn from "classnames";
// import Checkbox from "@components/new/Checkbox";
import Skeleton from "@components/new/Skeleton";
import { TableColumnSkeleton } from "./TableTypes.ts";
import styles from "./Table.module.scss";

export type TableRowProps = {
  columns: TableColumnSkeleton[];
  selectable?: boolean;
  verticalAlignment?: "top" | "center";
};

function TableRowSkeleton(props: TableRowProps): JSX.Element {
  return (
    <tr className={styles.row}>
      {props.selectable && (
        <td
          className={cn(
            styles.cell,
            styles["alignment-left"],
            styles[`vAlignment-${props.verticalAlignment ?? 'center'}`],
          )}
        >
          <div className={styles.content}>
            <Skeleton height="39px" width="100%" />
          </div>
        </td>
      )}

      {props.columns.map((column, index) => (
        <td
          className={cn(
            styles.cell,
            styles[`alignment-${column.alignment ?? 'left'}`],
            styles[`vAlignment-${props.verticalAlignment ?? 'center'}`],
          )}
          key={index}
          style={
            column.fixWidth === true
              ? { width: column.width }
              : { maxWidth: column.width }
          }
        >
          <div className={styles.content}>
            <Skeleton height="39px" width="100%" />
          </div>
        </td>
      ))}
    </tr>
  );
}

export default TableRowSkeleton;
